export default __webpack_public_path__ + "static/media/DryOasisMap.c7fdb010.jpg";